import React from 'react'
import { NavigationContainer } from '@src/screens/Common/containers'
import { AdminSettings as AdminSettingsComponent } from '../components/AdminSettings'

export const AdminSettingsContainer = () => {
  return (
    <NavigationContainer title="Admin Settings">
      <AdminSettingsComponent />
    </NavigationContainer>
  )
}
